import { Route, Routes } from "react-router-dom";
import Footer from "./components/common/Footer";
import Header from "./components/common/Header";
import Home from "./components/common/Home";

import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "./App.scss";
import EventsPage from "./components/events/EventsPage";
import FishFryPage from "./components/events/FishFryPage";
import GolfPage from "./components/events/GolfPage";
import LuckyCalendarPage from "./components/events/LuckyCalendarPage";
import NewsPage from "./components/events/NewsPage";
import PurchaseLuckyCalendarPage from "./components/events/PurchaseLuckyCalendarPage";
import PurseBingo from "./components/events/PurseBingo";

function App() {
  return (
    <div className="App">
      <Header />
      <main className="site-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/golf" element={<GolfPage />} />
          <Route path="/purse" element={<PurseBingo />} />
          <Route path="/pursebingo" element={<PurseBingo />} />
          <Route path="/purse-bingo" element={<PurseBingo />} />
          <Route path="/charity-purse-bingo" element={<PurseBingo />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/calendar" element={<LuckyCalendarPage />} />
          <Route path="/purchasecalendar" element={<PurchaseLuckyCalendarPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/fishfry" element={<FishFryPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;